<template>
   <div class="flex h-100">
      <div class="login-content container-mobile">
         <div class="logo-container">
            <img src="/img/logo.png" alt="Logo BeePerf" />
         </div>
         <div class="login-container">
            <div class="card" style="border-radius:5px;">
               <div class="card-content">
                  <b-message type="is-danger" v-if="message">{{ message }}</b-message>
                  <form @submit.prevent="login()">
                     <b-field label="E-mail">
                        <b-input type="email" v-model="username" required></b-input>
                     </b-field>
                     <b-field label="Mot de passe">
                        <b-input type="password" v-model="password" required></b-input>
                     </b-field>
                     <b-button native-type="submit" type="is-primary" :loading="loading">Connexion</b-button>
                  </form>
               </div>
            </div>
            <div class="flex is-size-6 liens" style="justify-content:space-between">
               <div>
                  <a href="http://api.beeperf.com/mot-de-passe-oublie" target="_blank">Mot de passe oublié</a>
               </div>
               <div>
                  <router-link :to="{ name: 'register' }">Créer un compte</router-link>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'Login',
   data() {
      return {
         username: '',
         password: '',
         loading: false,
         message: this.$route.params.message || ''
      };
   },
   methods: {
      login() {
         this.message = '';
         this.loading = true;
         this.$store
            .dispatch('login', {
               username: this.username,
               password: this.password
            })
            .then(() => {
               this.loading = false;
            });
      }
   }
};
</script>
